var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scan"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3843 20.3637C26.8402 20.3637 26.2959 20.7728 26.2959 21.4547V24.1819C26.2959 25.1364 25.4795 25.8183 24.6632 25.8183H21.9422C21.3979 25.8183 20.8538 26.2273 20.8538 26.9092C20.8538 27.5909 21.2619 28.0001 21.9422 28.0001H24.6632C26.704 28.0001 28.4727 26.3637 28.4727 24.1819V21.4547C28.4727 20.9092 27.9286 20.3637 27.3843 20.3637Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9422 6.18192H24.6632C25.6156 6.18192 26.2959 7.00009 26.2959 7.81828V10.5455C26.2959 11.091 26.7042 11.6365 27.3844 11.6365C28.0647 11.6365 28.4728 11.2274 28.4728 10.5455V7.81828C28.4728 5.77282 26.8402 4.00009 24.6632 4.00009H21.9422C21.398 4.00009 20.8538 4.40918 20.8538 5.091C20.8538 5.77282 21.398 6.18192 21.9422 6.18192Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0578 25.8183H8.33674C7.38436 25.8183 6.70409 25.0001 6.70409 24.1819V21.4547C6.70409 20.9092 6.29593 20.3637 5.61565 20.3637C4.93538 20.3637 4.52722 20.9092 4.52722 21.4547V24.1819C4.52722 26.2273 6.15988 28.0001 8.33674 28.0001H11.0578C11.602 28.0001 12.1463 27.5909 12.1463 26.9092C12.1463 26.2273 11.602 25.8183 11.0578 25.8183Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.61565 11.6365C6.15988 11.6365 6.70409 11.2274 6.70409 10.5455V7.81828C6.70409 6.86373 7.52042 6.18192 8.33674 6.18192H11.0578C11.602 6.18192 12.1463 5.77282 12.1463 5.091C12.1463 4.40918 11.602 4.00009 11.0578 4.00009H8.33674C6.29593 4.00009 4.52722 5.77282 4.52722 7.81828V10.5455C4.52722 11.091 5.07143 11.6365 5.61565 11.6365Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.9422 24.1819C23.4388 24.1819 24.6634 22.9547 24.6634 21.4547V19.0002H8.33679V21.4547C8.33679 22.9547 9.56129 24.1819 11.0579 24.1819H21.9422Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.745 14.9092H24.6634V10.5456C24.6634 9.04563 23.4388 7.81836 21.9422 7.81836H11.0578C9.56125 7.81836 8.33675 9.04563 8.33675 10.5456V15.182H4.25513C3.7109 15.182 3.16669 15.5911 3.16669 16.273C3.16669 16.9547 3.57485 17.3638 4.25513 17.3638H28.745C29.2891 17.3638 29.8334 16.9547 29.8334 16.273C29.8334 15.5911 29.2891 14.9092 28.745 14.9092Z",
    fill: "#F8C200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan-icon.79e3467d4e49aa1c75cc0512972e23b2.svg";
export { ForwardRef as ReactComponent };